import { action, computed } from 'mobx';
import {
    bpmsResourcesManagerApi,
    scoringModelSettingsApi,
} from 'src/services/apiServices';
import { AsyncOperationWithStatus } from 'src/utils/BasicStore/AsyncOperationWithStatus';
import { BasicStore } from 'src/utils/mobx/BasicStore/BasicStore';
import { BasicStoreApi } from 'src/utils/mobx/BasicStore/BasicStore.types';
import { RequestHelper } from 'src/utils/RequestHelper';

export class SettingsScoringModelStoreClass extends BasicStore<any> {
    itemDetailsFormKey =
        'embedded:deployment:forms/bo/bo-65-scoring-model.json';

    itemEditFormKey = 'embedded:deployment:forms/bo/bo-65-scoring-model.json';

    api: BasicStoreApi<any> = {
        loadList: async (...args: any[]) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const response = await RequestHelper.unwrapFromAxiosPromise(
                scoringModelSettingsApi.getScoringModelSettings(options),
            );

            return response.scoringModelSettingsList || [];
        },

        loadItemForm: (formKey: string, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            return RequestHelper.unwrapFromAxiosPromise(
                bpmsResourcesManagerApi.getForm({ formKey }, options),
            );
        },
        loadItem: (id, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const modelId = this.list?.[0]?.id;

            return RequestHelper.unwrapFromAxiosPromise(
                scoringModelSettingsApi.getScoringModelVersionSettings(
                    { id: modelId || 1, versionId: id },
                    options,
                ),
            );
        },
        updateItem: (id, data, ...args) => {
            const options = RequestHelper.getOptionsFromArgs(args);

            const modelId = this.list?.[0]?.id;

            return RequestHelper.unwrapFromAxiosPromise(
                scoringModelSettingsApi.addNewVersion(
                    {
                        id: modelId,
                        versionId: Number(id),
                        addNewVersionRequest: data,
                    },
                    options,
                ),
            );
        },
    };

    listOfModelVersions = new AsyncOperationWithStatus((modelId, ...args) => {
        const options = RequestHelper.getOptionsFromArgs(args);

        // Use the passed modelId or fallback to the first item's id
        const id = modelId || this.list?.[0]?.id || 1;

        return RequestHelper.unwrapFromAxiosPromise(
            scoringModelSettingsApi.getScoringModelVersionsSettings(
                { id },
                options,
            ),
        );
    });

    @computed get scoringModelId() {
        return this.listLoader?.data?.[0]?.id;
    }

    @action async loadVersionsList(modelId?: any) {
        const id = modelId || this.scoringModelId;
        if (id) {
            await this.listOfModelVersions.call(id);
        }
    }

    @computed get listVersions() {
        // console.log(
        //    'scoring: listVersions',
        //    toJS(this.listOfModelVersions?.data),
        // );

        return this.listOfModelVersions?.data?.content;
    }
}

export const SettingsScoringModelStore = new SettingsScoringModelStoreClass();
